import { actionTypes } from '../constants';

export const changeDesksSettingsPageReset = () => ({
  type: actionTypes.changeDesksSettingsPageReset,
});
